<section class="mu-home font-size-14" *ngIf="queryDetailsForm">
  <div class="container">
    <div class="row">
      <div class="col-lg-12 offset-lg-0 col-md-11 offset-md-1 col-12">
        <div class="col-12">
          <form [formGroup]="queryDetailsForm">
            <div class="row">
              <div class="col-md-12 text-end">
                <a>
                  <button type="button" class="btn-actvtytp" (click)="downloadQuery()">DOWNLOAD</button>
                </a>
              </div>
              <div class="col-md-12 mb-2 empl-tptxt">
                <h3 class="mb-0">View/Update Query Details</h3>
              </div>
              <div class="row row-cols-6">
                <div class="col-md-6 col-12">
                  <div class="row p-2">
                    <div class="col-4">Query ID</div>
                    <div class="col">{{ f.displayId.value }}</div>
                  </div>
                  <div class="row p-2">
                    <div class="col-4">Query Name</div>
                    <div class="col">{{ f.title.value }}</div>
                  </div>
                  <div class="row p-2">
                    <div class="col-4">Category</div>
                    <div class="col">{{ this.query?.taskCategory }}</div>
                  </div>
                  <div class="row p-2">
                    <div class="col-4">Sub Category</div>
                    <div class="col">{{ this.query?.taskSubCategory }}</div>
                  </div>
                  <div class="row p-2">
                    <div class="col-4">Description</div>
                    <div class="col" style="white-space: pre-line; word-break: break-all">
                      {{ f.description.value }}
                    </div>
                  </div>
                  <div *ngIf="user?.userType === userType.EMPLOYEE_ADMIN" class="col">
                    <div class="row p-2">
                      <div class="col-4">Category of Query</div>
                      <div class="col">{{ getOptionsValue(queryCategories, this.query?.queryCategory) }}</div>
                    </div>
                  </div>
                  <div class="row p-2">
                    <div class="col-4">Days Elapsed</div>
                    <div class="col">{{ f.daysElapsed.value }}</div>
                  </div>
                  <div class="row p-2">
                    <div class="col-4">Query Raised On</div>
                    <div class="col">{{ f.createdDatetime.value }}</div>
                  </div>
                  <div class="row p-2">
                    <div class="col-4">Next Action By</div>
                    <div class="col">{{ f.nextAction?.value }}</div>
                  </div>
                  <div *ngIf="user?.userType === userType.EMPLOYEE_ADMIN" class="col">
                    <div class="row p-2">
                      <div class="col-4">Dept Timeline</div>
                      <div class="col">{{ formatDateToDDMMYYYY(this.query?.epfoTimeline) }}</div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-md-6 col-12">
                      <div class="p-2">
                        <app-status-selector
                          [selectedStatus]="query?.status"
                          [categoryName]="query?.taskCategory"
                          [subCategoryName]="query?.taskSubCategory"
                          [moduleName]="MODULENAME"
                          [code]="query?.taskCode"
                          [isRequired]="true"
                          (onSelect)="onStatusSelected($event)"
                          (onStatusChange)="onStatusChange($event)"></app-status-selector>
                      </div>
                    </div>
                    <div *ngIf="user?.userType === userType.RMS_ADMIN" class="col-md-6 col-12">
                      <div class="p-2">
                        <label for="exampleFormControlInput1" class="form-label">Category of Query <sup>*</sup></label>
                        <select
                          class="form-select"
                          aria-label="Default select example"
                          [formControlName]="QUERY_CATEGORY_CONTROL_NAME"
                          [ngClass]="{
                            'is-invalid': f['queryCategory'].errors && f['queryCategory'].touched
                          }">
                          <option [disabled]="true" selected value="">Select Category</option>
                          <option *ngFor="let category of queryCategories" value="{{ category?.key1 }}">
                            {{ category?.key2 }}
                          </option>
                        </select>
                        <app-validation
                          field="queryCategory"
                          [form]="queryDetailsForm"
                          [error]="{
                            required: 'Please select Category of Query'
                          }">
                        </app-validation>
                      </div>
                    </div>
                  </div>
                  <div *ngIf="user?.userType === userType.RMS_ADMIN" class="row">
                    <div class="col-md-6 col-12">
                      <div class="p-2">
                        <label for="exampleFormControlInput1" class="form-label">Priority Level</label>
                        <select
                          class="form-select"
                          aria-label="Default select example"
                          [formControlName]="QUERY_PRIORITY_CONTROL_NAME">
                          <option [disabled]="true" selected value="">Select Priority Level</option>
                          <option *ngFor="let priority of priorityLevels" value="{{ priority?.key1 }}">
                            {{ priority?.key2 }}
                          </option>
                        </select>
                      </div>
                    </div>
                    <div class="col-md-6 col-12">
                      <div class="p-2">
                        <label for="nextInternalDueDate" class="form-label">Next Internal Due Date</label>
                        <input type="date" class="form-control" formControlName="nextInternalDueDate" />
                      </div>
                    </div>
                  </div>
                  <div *ngIf="user?.userType === userType.RMS_ADMIN" class="row">
                    <div class="col-md-6 col-12">
                      <div class="p-2">
                        <label for="epfoTimeline" class="form-label"
                          >Dept Timeline <sup *ngIf="isEpfoTimelineRequired"> *</sup></label
                        >
                        <input
                          type="date"
                          class="form-control"
                          formControlName="epfoTimeline"
                          [ngClass]="{ 'is-invalid': f['epfoTimeline'].errors && f['epfoTimeline'].touched }" />
                        <app-validation
                          field="epfoTimeline"
                          [form]="queryDetailsForm"
                          [error]="{
                            required: 'Please select Dept Timeline'
                          }">
                        </app-validation>
                      </div>
                    </div>
                    <div class="col-md-6 col-12">
                      <div class="p-2">
                        <app-assign-to-selector
                          [selectedId]="query?.assignedTo"
                          [mandatory]="true"
                          [includeInactives]="true"
                          (selectedValueChange)="handleAssignToSelectedValue($event)"></app-assign-to-selector>
                      </div>
                    </div>
                  </div>
                  <div *ngIf="user?.userType === userType.RMS_ADMIN" class="row">
                    <div class="col-md-12">
                      <div class="p-2">
                        <label for="exampleFormControlTextarea1" class="form-label">Notes</label>
                        <textarea
                          class="form-control"
                          id="exampleFormControlTextarea1"
                          rows="2"
                          [formControlName]="NOTES_CONTROL_NAME"></textarea>
                      </div>
                    </div>
                  </div>
                  <div *ngIf="user?.userType === userType.RMS_ADMIN" class="row">
                    <div class="col-md-6 col-12">
                      <div class="p-2" *ngIf="queryTags?.length > 0">
                        <label for="exampleFormControlInput1" class="form-label">Tag</label>
                        <tag-input [formControlName]="QUERY_TAG_CONTROL_NAME">
                          <tag-input-dropdown
                            [autocompleteItems]="queryTags"
                            [showDropdownIfEmpty]="true"
                            [dynamicUpdate]="false">
                          </tag-input-dropdown>
                        </tag-input>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-md-6 col-12">
                  <div class="accordion" id="employeeDetailsAccordion">
                    <div class="accordion-item">
                      <h2 class="accordion-header" id="employeeDetailsHeading">
                        <button
                          class="side-panel-label accordion-button collapsed"
                          type="button"
                          data-bs-toggle="collapse"
                          data-bs-target="#employeeDetailsContent"
                          aria-expanded="true"
                          aria-controls="employeeDetailsContent">
                          Employee Details
                        </button>
                      </h2>
                      <div
                        id="employeeDetailsContent"
                        class="collapsed collapse"
                        aria-labelledby="employeeDetailsHeading"
                        data-bs-parent="#employeeDetailsAccordion">
                        <div class="accordion-body">
                          <div class="row">
                            <div class="col-4">Employee Code</div>
                            <div class="col">{{ f.ownerDisplayId.value }}</div>
                          </div>
                          <div class="row">
                            <div class="col-4">Employee Name</div>
                            <div class="col">{{ f.empName.value }}</div>
                          </div>
                          <div class="row">
                            <div class="col-4">Employee DOJ</div>
                            <div class="col">{{ f.empDoj.value }}</div>
                          </div>
                          <div class="row">
                            <div class="col-4">Employee Status</div>
                            <div class="col">{{ f.empStatus.value }}</div>
                          </div>
                          <div class="row">
                            <div class="col-4">Employee PF Number</div>
                            <div class="col">{{ f.empCurrentPfNumber.value }}</div>
                          </div>
                          <div class="row">
                            <div class="col-4">Employee UAN Number</div>
                            <div class="col">{{ f.empUanNumber.value }}</div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="accordion" id="employeeLinkedQueryDetailsAccordion">
                    <div class="accordion-item">
                      <h2 class="accordion-header" id="employeeLinkedQueryDetailsHeading">
                        <button
                          class="side-panel-label accordion-button collapsed"
                          type="button"
                          data-bs-toggle="collapse"
                          data-bs-target="#employeeLinkedQueryDetailsContent"
                          aria-expanded="true"
                          aria-controls="employeeLinkedQueryDetailsContent"
                          (click)="fetchEmployeeLinkedQueryDetails()">
                          Employee's Other Queries
                        </button>
                      </h2>
                      <div
                        id="employeeLinkedQueryDetailsContent"
                        class="collapsed collapse"
                        aria-labelledby="employeeLinkedQueryDetailsHeading"
                        data-bs-parent="#employeeLinkedQueryDetailsAccordion">
                        <div class="accordion-body" style="max-height: 400px; overflow-y: auto; overflow-x: hidden">
                          <table class="table table-striped table-bordered">
                            <thead>
                              <tr>
                                <th class="serial-no-column" scope="col">S. No</th>
                                <th scope="col">ID</th>
                                <th scope="col">Status</th>
                                <th scope="col">Query Raised On</th>
                                <th class="more-info-column" scope="col">Action</th>
                              </tr>
                            </thead>
                            <tbody>
                              <ng-container
                                *ngFor="let employeeLinkedQueryDetails of employeeLinkedQueryArray; let i = index">
                                <tr>
                                  <td class="serial-no-column">
                                    {{ i + 1 }}
                                  </td>
                                  <td>
                                    <a [href]="getQueryDetailsUrl(employeeLinkedQueryDetails[0])" target="_blank">
                                      {{ employeeLinkedQueryDetails[1] }}
                                    </a>
                                  </td>
                                  <td>
                                    {{ employeeLinkedQueryDetails[2] }}
                                  </td>
                                  <td>{{ employeeLinkedQueryDetails[5] }}</td>
                                  <td class="more-info-column">
                                    <button
                                      class="more-info-accordion-button collapsed"
                                      type="button"
                                      data-bs-toggle="collapse"
                                      [attr.data-bs-target]="'#additionalInfoContent_' + i"
                                      aria-expanded="false"
                                      [attr.aria-controls]="'additionalInfoContent_' + i">
                                      View more
                                    </button>
                                  </td>
                                </tr>
                                <td style="padding: 0px" colspan="4">
                                  <div id="additionalInfoContent_{{ i }}" class="collapsed collapse">
                                    <div class="more-info-accordion-body">
                                      <table class="table table-bordered" style="table-layout: fixed">
                                        <tbody>
                                          <tr>
                                            <td style="width: 35%">Category of Query</td>
                                            <td class="description-cell">{{ employeeLinkedQueryDetails[4] }}</td>
                                          </tr>
                                          <tr>
                                            <td>Description</td>
                                            <td class="description-cell">{{ employeeLinkedQueryDetails[3] }}</td>
                                          </tr>
                                        </tbody>
                                      </table>
                                    </div>
                                  </div>
                                </td>
                              </ng-container>
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-12">
                    <app-comment
                      [comments]="query?.comments"
                      (add)="addComment($event)"
                      [statusChange]="statusValueChange"
                      (mandatoryflag)="mandatoryflag($event)"
                      (notifyChange)="getIfNotifySelected($event)"></app-comment>
                  </div>
                  <div class="col-12">
                    <p class="side-panel-label">Reminder Options</p>
                    <div class="d-flex gap-4">
                      <div class="form-check form-check-inline" *ngFor="let option of queryReminderOptions">
                        <input
                          class="form-check-input border border-secondary"
                          type="radio"
                          [id]="option.id"
                          [value]="option.value"
                          formControlName="reminderType"
                        />
                        <label class="form-check-label" [for]="option.id">{{ option.label }}</label>
                      </div>
                    </div>
                  </div>
                  <div class="col-12">
                    <p class="side-panel-label">Upload Documents</p>
                    <app-multiple-file-selector
                      [maxAllowedSizeInMB]="2"
                      [allowedTypes]="[
                        'application/pdf',
                        'image/jpeg',
                        'image/png',
                        'application/msword',
                        'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
                        'message/rfc822'
                      ]"
                      (chooseFiles)="handleFileInput($event)"
                      (removeFiles)="clearSelectedFiles($event)"></app-multiple-file-selector>
                  </div>
                  <div class="col-12">
                    <div class="p-2">
                      <app-attachment-list
                        [referenceId]="id"
                        [canDownloadAll]="true"
                        [attachments]="query?.documents"
                        [companyEntityId]="query?.companyEntityId"></app-attachment-list>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-12 d-flex justify-content-end acvtypglastbtn">
                <a>
                  <button
                    type="button"
                    class="btn"
                    (click)="updateQuery()"
                    [disabled]="!queryDetailsForm.valid || isDisabled">
                    SAVE & EXIT
                  </button>
                </a>
                <a>
                  <button type="button" class="btn-discard" [routerLink]="QUERY_SUMMARY_LINK">EXIT</button>
                </a>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</section>
